export const uploadProgressBarSpeed = 3; // default speed (percents per second)
export const uploadProgressBarInterval = 3000; // interval (in ms)

/**
 *
 * @type {([{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},null,null,null]|[{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},null,null,null]|[{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},null,null,null]|[{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string},{r: boolean, t: string}]|[{r: boolean, t: string},{r: boolean, t: string}])[]}
 */
export const NES_CLASSES = [
    [
        {'t': 'ЕГРН - страница 1', 'r': true},
        {'t': 'ЕГРН - страница 2', 'r': true},
        {'t': 'ЕГРН - прочие страницы', 'r': false},
        {'t': 'Паспорт', 'r': false},
        {'t': 'Свидетельство о регистрации права', 'r': false},
        {'t': 'ДКП - страница 1', 'r': false},
        {'t': 'ДКП - промежуточная страница', 'r': false},
        {'t': 'ДКП - последняя страница', 'r': false}
    ],
    [
        {'t': 'Свидетельство о регистрации права', 'r': true},
        {'t': 'Паспорт', 'r': false},
        {'t': 'ДКП - страница 1', 'r': false},
        {'t': 'ДКП - промежуточная страница', 'r': false},
        {'t': 'ДКП - последняя страница', 'r': false},
        {'t': 'ЕГРН - страница 1', 'r': false},
        {'t': 'ЕГРН - страница 2', 'r': false},
        {'t': 'ЕГРН - прочие страницы', 'r': false}
    ],
    [
        {'t': 'ДКП - страница 1', 'r': true},
        {'t': 'ДКП - промежуточная страница', 'r': false},
        {'t': 'ДКП - последняя страница', 'r': true},
        {'t': 'Паспорт', 'r': false},
        {'t': 'Свидетельство о регистрации права', 'r': false},
        {'t': 'ЕГРН - страница 1', 'r': false},
        {'t': 'ЕГРН - страница 2', 'r': false},
        {'t': 'ЕГРН - прочие страницы', 'r': false}
    ],
    [
        {'t': 'Договор соц. найма - страница 1', 'r': true},
        {'t': 'Договор соц. найма - промежуточная страница', 'r': false},
        {'t': 'Договор соц. найма - последняя страница', 'r': true},
        {'t': 'Паспорт', 'r': false},
    ],
    [
        {'t': 'Свидетельство о праве на наследство', 'r': true},
        {'t': 'Паспорт', 'r': false},
    ],
    [
        {'t': 'Акт приема-передачи жилого помещения', 'r': true},
        {'t': 'Паспорт', 'r': false},
    ],
    [
        {'t': 'Договор найма служебного помещения - страница 1', 'r': true},
        {'t': 'Договор найма служебного помещения - промежуточная страница', 'r': false},
        {'t': 'Договор найма служебного помещения - последняя страница', 'r': true},
        {'t': 'Паспорт', 'r': false},
    ],
    [
        {'t': 'ЕГРН - страница 1', 'r': true},
        {'t': 'ЕГРН - страница 2', 'r': true},
        {'t': 'ЕГРН - прочие страницы', 'r': false},
        {'t': 'Договор о дарении', 'r': false},
    ],
    [
        {'t': 'Договор о дарении - страница 1', 'r': true},
        {'t': 'Договор о дарении - промежуточная страница', 'r': false},
        {'t': 'Договор о дарении - последняя страница', 'r': true},
    ],
    [
        {'t': 'Договор найма жилого помещения - страница 1', 'r': true},
        {'t': 'Договор найма жилого помещения - промежуточная страница', 'r': false},
        {'t': 'Договор найма жилого помещения - последняя страница', 'r': true},
    ]
]